import _ from "lodash";
import { matchPath, useLocation } from "react-router";
import { routes } from "../../app/routes";
import { AppFooter } from "./AppFooter";

const PAGES_WITHOUT_FOOTER = [
    routes.login(),
    routes.signup(),
    { path: routes.home(), exact: true },
    routes.teacherPostSession(":sanghaId"),
    routes.memberSanghaDetails(":sanghaId"),
    routes.memberUpdateBilling(),
    routes.memberSanghas(),
    routes.memberDropInSessionsMonthlyTheme(),
    routes.memberDropInSessionsMeditationsDiscussions(),
    routes.memberDropInSessionsTalks(),
    routes.memberMindfulFriends(),
    routes.memberTeachersPage(),
    routes.memberHomePage(),
    routes.memberSchedulePage(),
    { path: routes.memberZone(), exact: true },
    routes.cancelMembership(),
    routes.memberDonate(),
    routes.memberContribute(),
    routes.addMentorshipGroup(":sanghaId"),
    routes.setupConfirmInterestGroup(":groupId"),
    routes.memberConfirmInterestGroup(":groupId"),
    routes.setupAddInterestGroup(":groupId"),
    routes.testInterestGroupGuidelines(),
    routes.conflictResolution(),
    routes.memberDropInSessionsWelcomeSessions(),
    routes.memberOnboarding(),
    routes.memberUpdateLegacyBillingPage1(),
    routes.memberUpdateLegacyBillingPage2(),
    routes.memberUpdateLegacyBillingPage3(),
    routes.setupWelcomeSession(),
    routes.setupShowYouAround(),
    routes.editProfilePage(),
    routes.setupEditProfilePage(),
    routes.memberDropInSessionsAllSessions(),
    routes.communityGuidelines(),
    routes.contactUs(),
    routes.memberMembership(),
    routes.setupAllInterestGroups(),
    routes.allInterestGroups(),
    routes.memberAddInterestGroup(":groupId"),
    routes.addInterestGroup(":groupId"),
    routes.memberDropInSessionsSilentMeditations(),
];

const PAGES_WITHOUT_NEWSLETTER: string[] = [];

const skipFooter = (path: string): boolean => {
    return _.some(PAGES_WITHOUT_FOOTER, (route) => matchPath(path, route));
};

const skipNewsletter = (path: string): boolean => {
    return _.some(PAGES_WITHOUT_NEWSLETTER, (route) => matchPath(path, route));
};

export const AppFooterLoader = () => {
    const location = useLocation();

    if (skipFooter(location.pathname)) {
        return null;
    }

    return <AppFooter hideNewsletter={skipNewsletter(location.pathname)} />;
};
